

export default amd;
import packageResult from '../../../utils/packageResult';
import transformBody from './utils/transformBody';
import amdIntro from '../../../utils/amd/amdIntro';
function amd(mod, options) {
	var intro = amdIntro({
		name: options.amdName,
		absolutePaths: options.absolutePaths,
		imports: mod.imports,
		indentStr: mod.body.getIndentString(),
		hasExports: mod.exports.length,
		useStrict: options.useStrict !== false
	});

	transformBody(mod, mod.body, {
		intro: intro,
		outro: '\n\n});',
		_evilES3SafeReExports: options._evilES3SafeReExports
	});

	return packageResult(mod, mod.body, options, 'toAmd');
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/builders/strictMode/amd.js.01-babel.map